import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { ApiResult, throwApiError } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { EEBusMiddlewareDto } from '../../advanced-settings/charging-stations'

export type SmartMeterGatewayDto = {
  eebusController?: EEBusMiddlewareDto
  smartMeterGateway: {
    active: boolean
    ski: string | null
  }
}

export const getSmartMeterGatewayInfo = async (
  installationId: number,
  emcDeviceLinkId: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<SmartMeterGatewayDto | null>> => {
  if (!emcDeviceLinkId) {
    return new ApiResult(null, true, new Error('No EMC Device Link ID provided'))
  }

  try {
    const response = await authFetch<SmartMeterGatewayDto>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/device-links/${emcDeviceLinkId}/middlewares/smart-meter-gateway`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<SmartMeterGatewayDto>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to get smart meter gateway info:')
  }
}

export const scanForSmartMeterGatewayInfo = async (
  installationId: number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<{ ski: string; shipId: string; eebusId: string }[] | null>> => {
  try {
    const response = await authFetch<{ ski: string; shipId: string; eebusId: string }[]>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/device-links/middlewares/smart-meter-gateway/scan`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<{ ski: string; shipId: string; eebusId: string }[]>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to scan for smart meter gateway info:')
  }
}
